module.exports = __webpack_public_path__ + "static/media/logo.c9e6ebb8.svg";